import script from "./DataIngestionHistoryCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataIngestionHistoryCard.vue?vue&type=script&setup=true&lang=ts"

import "./DataIngestionHistoryCard.vue?vue&type=style&index=0&id=fe473716&lang=scss"

const __exports__ = script;

export default __exports__